import { Model } from './model';
import { ModelWithAddress } from './model-with-address';

import { Polizza } from './polizza';

export abstract class Contraente extends ModelWithAddress {

  nome: string;

  partita_iva: string;
  codice_fiscale: string;

  polizze: Polizza[];

  type!: string;
  IBAN: string;
  note: string;
  cell: string;
  tel: string;
  email: string;
  amministratore: any;
  dati_completi?: string;

  deserialize(input: any): Contraente {
    let retV: any = new Model();
    retV = super.deserialize(input)

    if (input?.polizze) {
      retV.polizze = input.polizze.map((p) => new Polizza().deserialize(p));
    }

    return retV;
  }

}
